import { createFileRoute, Link } from '@tanstack/react-router'
import { ChevronRight, Snowflake, Trophy } from 'lucide-react'
import { AppHeader } from '@/shared/components/layout/AppHeader'
import styles from './index.module.css'

// The admin root is a chooser, nothing else. Previously it mixed a link to the survivor
// panel with the fantasy panel's own controls inline, so it read as one confused page
// that was half menu and half tool.
export const Route = createFileRoute('/_authenticated/admin/')({
  component: AdminIndex,
})

function AdminIndex() {
  return (
    <>
      <AppHeader title="Admin" />
      <div className={styles.page}>
        <p className={styles.lead}>Escolha qual painel você quer operar.</p>

        <div className={styles.options}>
          <PanelOption
            to="/admin/sobrevivente"
            icon={<Trophy size={22} />}
            title="Painel do Sobrevivente"
            description="Competições, times, calendário e a rotina das rodadas: bloquear, buscar resultados e finalizar."
            tag="Em operação"
            tagVariant="live"
          />

          <PanelOption
            to="/admin/fantasy"
            icon={<Snowflake size={22} />}
            title="Painel do Fantasy"
            description="Escalações, estatísticas de jogadores, preços e elencos da competição existente."
            tag="Congelado"
            tagVariant="frozen"
          />
        </div>
      </div>
    </>
  )
}

type PanelOptionProps = {
  to:          string
  icon:        React.ReactNode
  title:       string
  description: string
  tag:         string
  tagVariant:  'live' | 'frozen'
}

function PanelOption({ to, icon, title, description, tag, tagVariant }: PanelOptionProps) {
  return (
    <Link to={to} className={styles.option}>
      <span className={styles.optionIcon}>{icon}</span>

      <span className={styles.optionBody}>
        <span className={styles.optionHead}>
          <span className={styles.optionTitle}>{title}</span>
          <span className={tagVariant === 'live' ? styles.tagLive : styles.tagFrozen}>
            {tag}
          </span>
        </span>
        <span className={styles.optionDescription}>{description}</span>
      </span>

      <ChevronRight size={18} className={styles.optionChevron} />
    </Link>
  )
}
